import { c as _c } from "react/compiler-runtime";
import { IconButton, Typography, Stack, Tooltip } from '@mui/material';
export const SelectedItemsHeader = t0 => {
  const $ = _c(11);
  const {
    clearAll,
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      justifyContent: "space-between"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Typography>{title}</Typography>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== clearAll) {
    t3 = event => {
      event.stopPropagation();
      clearAll();
    };
    $[3] = clearAll;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <i className="material-symbols-filter-alt-off-outline-rounded h-[18px] w-[18px]" />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <Tooltip title="Clear all"><IconButton color="primary" onClick={t3}>{t4}</IconButton></Tooltip>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t5) {
    t6 = <Stack direction="row" className="w-full" sx={t1}>{t2}{t5}</Stack>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};